// extracted by mini-css-extract-plugin
module.exports = {"addWrap":"Levels_addWrap__1lzxt","addNew__icon":"Levels_addNew__icon__u2o_6","addNew__text":"Levels_addNew__text__2ca2M","goBack__icon":"Levels_goBack__icon__3-So4"};